/**
 * Lo que hay que revisar (alertas del backend: rebote alto, bajas altas, apertura baja, campañas sin la baja en un
 * clic), cada cosa con qué hacer. Las rojas primero. En el resumen cada una lleva el link a su campaña.
 *
 * Lo que se hace en la cuenta de Snov (`equipo`) lo ve sólo el equipo: la cuenta es de Deenex y un cliente no entra.
 */

import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import type { Alerta } from "../types";
import { R_EMAILS } from "../logic/emails";
import { useEsEquipoDeenex } from "../../campana-nueva/hooks/useEsEquipoDeenex";

const CLS = { rojo: "border-red-200 bg-red-50 text-red-900", ambar: "border-amber-200 bg-amber-50 text-amber-900" } as const;
const ICONO = { rojo: "text-red-600", ambar: "text-amber-600" } as const;

export function Alertas({ alertas, conCampana = false }: { alertas: Alerta[]; conCampana?: boolean }) {
  const equipo = useEsEquipoDeenex();
  if (!alertas.length) return null;
  return (
    <ul className="space-y-2" aria-label="Para revisar">
      {alertas.map((a) => (
        <li key={`${a.campanaId}-${a.codigo}`} className={`flex items-start gap-2.5 rounded-xl border px-3.5 py-2.5 text-sm ${CLS[a.nivel]}`}>
          <AlertTriangle size={15} className={`mt-0.5 flex-shrink-0 ${ICONO[a.nivel]}`} aria-hidden="true" />
          <div className="min-w-0">
            <p className="font-semibold">
              {a.titulo}
              {conCampana && (
                <>
                  {" · "}
                  <Link to={`${R_EMAILS}/campanas/${encodeURIComponent(String(a.campanaId))}`} className="font-normal underline break-words">{a.campana || `Campaña ${a.campanaId}`}</Link>
                </>
              )}
            </p>
            <p className="mt-0.5 opacity-90">
              {a.detalle}
              {a.equipo && (equipo ? ` ${a.equipo}` : " Si querés cambiarlo, avisale a tu contacto de Deenex.")}
            </p>
          </div>
        </li>
      ))}
    </ul>
  );
}

export default Alertas;
